/* 0511ER – Versandleiste oben: Fortschritt bis zum kostenlosen Versand, aktualisiert bei jeder Warenkorb-Änderung. */
(function () {
  var el = document.querySelector('[data-versandleiste]');
  if (!el) return;
  var ab = parseInt(el.getAttribute('data-ab'), 10) || 0;
  var txt = el.querySelector('[data-versand-text]');
  var bar = el.querySelector('[data-versand-bar]');
  var format = el.getAttribute('data-format') || '€{{amount_with_comma_separator}}';

  function geld(cent) {
    var e = (cent / 100).toFixed(2).split('.');
    var tausend = function (s, t) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, t); };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, art) {
      if (art === 'amount_with_comma_separator') return tausend(e[0], '.') + ',' + e[1];
      if (art === 'amount_no_decimals') return tausend(e[0], ',');
      if (art === 'amount_no_decimals_with_comma_separator') return tausend(e[0], '.');
      return tausend(e[0], ',') + '.' + e[1];
    });
  }

  function zeige(summe) {
    if (!txt || !bar) return;
    if (summe <= 0) {
      txt.textContent = el.getAttribute('data-start');
      bar.style.width = '0%';
      el.classList.remove('ist-frei');
    } else if (summe >= ab) {
      txt.textContent = el.getAttribute('data-frei');
      bar.style.width = '100%';
      el.classList.add('ist-frei');
    } else {
      txt.textContent = el.getAttribute('data-rest').replace('[betrag]', geld(ab - summe));
      bar.style.width = Math.round(summe / ab * 100) + '%';
      el.classList.remove('ist-frei');
    }
  }

  function hole() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { zeige(c.total_price || 0); })
      .catch(function () {});
  }

  var original = window.fetch;
  window.fetch = function (eingabe) {
    var p = original.apply(this, arguments);
    try {
      var url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(hole, 60); });
    } catch (e) {}
    return p;
  };
  window.addEventListener('pageshow', function (e) { if (e.persisted) hole(); });
})();
